import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';

import { Fields, reduxForm } from 'redux-form';

import MultiselectAutosuggestField from 'components/fields/MultiselectAutosuggestField';

import {
  requestSearchDocumentCategories, requestFetchDocumentCategories,
} from 'redux/modules/documentCategories';
import { accountLoginFail } from 'redux/modules/account';

const styles = () => ({
  buttons: {
    marginTop: 20,
  },
  buttonsCreate: {
    textAlign: 'right',
  },
  button: {
    '& + $button': {
      marginLeft: 20,
    },
  },
  formError: {
    marginBottom: 16,
  },
  checkboxField: {
    marginBottom: 8,
  },
  grid: {
    marginTop: 10,
    '&:first-child': {
      marginTop: 0,
    },
  },
});

function onChange(values, dispatch, props) {
  if (values['Selected Documents Category']) {
    if (!values['Documents Category']
      || values['Documents Category'].findIndex(item =>
        item.value === values['Selected Documents Category'].value) === -1) {
      props.array.push('Documents Category', values['Selected Documents Category']);
    }
    props.clearFields(false, false, 'Selected Documents Category');
  }
}

const DocumentsFilterForm = ({
  handleSubmit,
  change,
  actions,
  className,
  filterInputRef,
}) => (
  <form
    className={className}
    noValidate
    autoComplete="off"
    onSubmit={handleSubmit}
  >
    <Fields
      names={[
        'Documents Category Name',
        'Documents Category',
      ]}
      autosuggestFieldName="Documents Category Name"
      fieldArrayName="Documents Category"
      placeholder="-Search by Category-"
      component={MultiselectAutosuggestField}
      renderSuggestionContent={suggestion =>
        suggestion.Name}
      renderInputContent={suggestion =>
        suggestion.Name}
      onSuggestionSelected={(suggestion) => {
        change('Selected Documents Category', {
          value: suggestion.ID,
          label: suggestion.Name,
        });
        return '';
      }}
      fetchSuggestions={({ value, limit, offset, fieldArrayValue }) => (
        value.length > 0 || (fieldArrayValue && fieldArrayValue.length > 0)
          ? requestSearchDocumentCategories({
            filters: [
              ...value.length > 0
                ? [{
                  name: 'Name',
                  operation: 'startswith',
                  val: value,
                  case_sensitivity: false,
                }] : [],
              ...fieldArrayValue && fieldArrayValue.length > 0
                ? fieldArrayValue.map(item => ({
                  name: 'ID',
                  operation: 'ne',
                  val: item.value,
                }))
                : [],
            ],
            limit,
            offset,
          }).then(res => res.data,
            (err) => {
              if (err.data.error === 'Need authorisation') {
                actions.accountLoginFail();
              }
              return err;
            })
          : requestFetchDocumentCategories({
            limit,
            offset,
          }).then(res => res.data,
            (err) => {
              if (err.data.error === 'Need authorisation') {
                actions.accountLoginFail();
              }
              return err;
            })
      )}
      keepOpenAfterSelection
      textFieldRef={filterInputRef}
    />
  </form>
);

DocumentsFilterForm.propTypes = {
  className: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
  change: PropTypes.func.isRequired,
  filterInputRef: PropTypes.func,
  actions: PropTypes.shape({
    accountLoginFail: PropTypes.func.isRequired,
  }).isRequired,
};

DocumentsFilterForm.defaultProps = {
  onCancelButtonClick: () => {},
  initialValues: {},
  error: null,
  onSubmitButtonBlur: () => {},
  inputRef: () => {},
  onSubmitButtonClick: () => {},
  className: '',
  filterInputRef: () => {},
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ accountLoginFail }, dispatch),
});

export default connect(null, mapDispatchToProps)(
  reduxForm({
    onChange,
  })(withStyles(styles)(DocumentsFilterForm)),
);



// WEBPACK FOOTER //
// ./src/components/patient/PatientProfile/Documents/DocumentsFilterForm.js